import { useEffect, useState } from 'react';

import { STATE, ResponseError } from '../PermanentLinkScreen.interface';
import { isUpcomingEvent } from '../PermanentLinkScreen.utils';

export const usePermanentLinkScreenState = (isRequesting: boolean, id: string, responseError: ResponseError) => {
    const [state, setState] = useState<STATE>(STATE.LOADING);

    useEffect(() => {
        if (isRequesting) {
            setState(STATE.LOADING);
            return;
        }

        if (id) {
            setState(STATE.REDIRECT);
            return;
        }

        if (responseError) {
            if (isUpcomingEvent(responseError)) {
                setState(STATE.DISPLAY_NEXT_EVENT);
            } else {
                setState(STATE.ERROR);
            }
        }
    }, [responseError, id, isRequesting]);

    return state;
};
